module.exports = __webpack_public_path__ + "img/camera_pairing_mode.40668fde.png";